import { Component, ContentChildren, EventEmitter, Input, Output, QueryList, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormFunctions } from 'src/app/functions';
import { FilterItemValue } from '../../../models';


@Component({
    selector: 'modal-create-custom-filter',
    styleUrls: ['./modal-create-custom-filter.component.scss'],
    templateUrl: 'modal-create-custom-filter.component.html'
})
export class ModalCreateCustomFilterComponent {
    @ContentChildren(NgModel, { descendants: true }) public models: QueryList<NgModel>;
    @ViewChild(NgForm) public form: NgForm;

    @Input() modalMode: boolean = true;

    @Output() apply: EventEmitter<any> = new EventEmitter();
    inputValue : string;

    constructor(public activeModal: NgbActiveModal, private formFunctions: FormFunctions) {
        let me = this;
    }

    check(e) {
        this.inputValue = e.target.value
    }

    public ngAfterViewInit(): void {
        let ngContentModels = this.models.toArray();
        ngContentModels.forEach((model) => {
            this.form.addControl(model);
        });
    }

    Save() {
        let me = this;
        me.apply.emit(this.inputValue);
        me.activeModal.close();
    }

    Close() {
        this.activeModal.close(null);
    }

}